import cx from 'classnames';
import React from 'react';
import type { ButtonProps } from 'reactstrap';
import { Button as ReactstrapButton } from 'reactstrap';

export function Button({
  children,
  transparent = false,
  animate = true,
  className,
  color,
  disabled,
  id,
  ...props
}: {
  id?: string;
  transparent?: boolean;
  className?: string;
  color?: string;
  disabled?: boolean;
  animate?: boolean;
  children: React.ReactNode;
} & ButtonProps) {
  return (
    <ReactstrapButton
      {...props}
      id={id}
      className={cx(
        {
          'bg-transparent shadow-none': transparent,
          animated: transparent && animate && !disabled,
        },
        className
      )}
      color={transparent ? 'none' : color}
      disabled={disabled}
    >
      {children}
    </ReactstrapButton>
  );
}
